export const claimsPhysicianHistoryColumns = [
  'id',
  'fk_claim_id',
  'fk_claims_meta_data_id',
  'relationship',
  'first_name',
  'last_name',
  'middle_name',
  'npi',
  'physician_837_indicator',
  'role',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'meta_scrubbed_data',
  'snapshot_id',
  'meta_lineage_content_hash',
];
